import React from 'react'
import clsx from 'clsx'

import { useTheme } from '@material-ui/core/styles'
import {
  Box,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Tooltip
} from '@material-ui/core'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'

import { useSettingsPageStyles } from '../../hooks/settingsPageStylesHook'

import { OrderPriceType } from '../../server/mpsklad_core/Entity/Enums/OrderPriceType'
import { integrationTypeNames, StoreIntegrationType } from '../../types/integrationTypeUtils'

export type OrderPriceTypePickerProps = {
  storeType: StoreIntegrationType
  orderPriceType: OrderPriceType
  onOrderPriceTypeChange: (value: OrderPriceType) => void
}

export const OrderPriceTypePicker =
  ({storeType, orderPriceType, onOrderPriceTypeChange}: OrderPriceTypePickerProps) => {
    const {palette} = useTheme()
    const classes = useSettingsPageStyles()

    const marketplaceName = integrationTypeNames[storeType]

    return (
      <Grid item xs={9}>
        <Grid container className={clsx(classes.settingsTopic, 'default-border')}>
          <Grid item className={classes.root} xs={12}>
            <Box width={'100%'} display="flex" flexDirection="column">
              <Box>
                <FormLabel className={classes.unifiedPricesLabel}>
                  Цена продажи в заказах
                </FormLabel>

                <FormHelperText className={classes.helperText}>
                  Выберите, какая цена будет устанавливаться в заказах {marketplaceName} при создании документа в
                  МоёмСкладе
                </FormHelperText>
              </Box>

              <RadioGroup
                value={orderPriceType}
                onChange={e => onOrderPriceTypeChange(parseInt(e.target.value))}
              >
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                  <Box display="flex" alignItems="center">
                    <FormLabel className={classes.unifiedPricesLabel}>
                      Цена продавца (без скидки)
                    </FormLabel>

                    <Tooltip
                      title={`Будет установлена исходная цена продавца без учёта скидок ${marketplaceName}`}
                      arrow>
                      <IconButton size="small" className={classes.helperIcon}>
                        <HelpOutlineIcon fontSize="small" style={{color: palette.mpSkladPrimary.blue}}/>
                      </IconButton>
                    </Tooltip>
                  </Box>

                  <FormControlLabel
                    label=""
                    value={OrderPriceType.FinishedPrice}
                    control={<Radio/>}
                  />
                </Box>

                <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                  <Box display="flex" alignItems="center">
                    <FormLabel className={classes.unifiedPricesLabel}>
                      Цена с учётом скидки {marketplaceName}
                    </FormLabel>

                    <Tooltip
                      title={`Будет установлена фактическая цена продажи с учётом скидок и акций ${marketplaceName}`}
                      arrow>
                      <IconButton size="small" className={classes.helperIcon}>
                        <HelpOutlineIcon fontSize="small" style={{color: palette.mpSkladPrimary.blue}}/>
                      </IconButton>
                    </Tooltip>
                  </Box>

                  <FormControlLabel
                    label=""
                    value={OrderPriceType.PriceWithDisc}
                    control={<Radio/>}
                  />
                </Box>
              </RadioGroup>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    )
  }